//@import dependencies
import React, {Component, Fragment} from 'react'
import {connect} from 'react-redux'
import { createGlobalStyle } from 'styled-components'
//@end

//@import styles
import 'app_styles/main.scss'
//@end

//@import routes
import AppNavigatorRoute from 'app_routers/components/AppNavigatorMasterRoute'
//@end

//@import components
import {FaviconCommonLayout} from 'app_components/commons/helmet/favicon'
import {TitleCommonLayout} from 'app_components/commons/helmet/title'
import {PreloaderCommonLayout} from 'app_components/commons/preloader'
import SupportButtonCommon from 'app_components/commons/helpDesk/SupportButtonCommon'
//@end

//@import third party libraries
import 'bootstrap/dist/js/bootstrap.bundle'
//@end

//@import third party libraries
import '@fortawesome/fontawesome-free/js/brands.js'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/fontawesome.js'
//@end

// @import services
import UserService from 'app_services/user/userService'
import storeService from 'app_services/storeService'
import ColorsService from 'app_services/colors/colorsService'
// @end

// @import config
import { customs } from 'app_config/globals'
import { IChatbotState } from 'app_events/app/types'
import { chatbotChange } from 'app_events/app/actions'
import LoginMoodleByRequest from 'app_components/modules/LoginMoodleByRequest/LoginMoodleByRequest'
// @end

// =================================
// This class name is in App.css
// =================================
const CLASS_NAME_CHATBOT = 'custom-chat-bot';
const INTERVAL_STYLES_CHATBOT = 200;

function mapStatesToProps(state: any = {}) {
  return state
}

interface IGlobalStyleProps {
  style: any
}

const GlobalStyle = createGlobalStyle<IGlobalStyleProps>`
  ${(props) => props.style}
`
class MasterLayout extends Component<any> {
  private userService: UserService
  private colorsService = new ColorsService()

  constructor(props: any) {
    super(props)
    this.userService = new UserService()
    this.userService.setI18nCustom()
  }

  state = {
    preloader: '',
    favicon: require('app_assets/images/favicons/favicon.png'),
    title: 'Icontec',
    stylesString: '',
    chatbotLoaded: false,
    chatbotOpen: false
  }

  componentDidMount() {
    this.setState({
      preloader: 'hidden',
    })

    storeService?.dispatch(chatbotChange({
      open: false,
      page: null,
      metadata: null
    }))
    // Suscribirme a los cambios de screen_mode
    storeService?.subscribe('auth.user.data.screen_mode', this.updateScreenMode)
    storeService?.subscribe('auth.isAuth', this.handleLogout)
    storeService?.subscribe('app.chatbot', this.handleChatbotChange)
  }

  componentWillUnmount() {
    storeService?.unsubscribe('auth.user.data.screen_mode', this.updateScreenMode)
    storeService?.unsubscribe('auth.isAuth', this.handleLogout)
    storeService?.unsubscribe('app.chatbot', this.handleChatbotChange)
  }

  /**
   * @INFO Cambio de screen mode
   * @param mode : string con el modo elegido
   */
  updateScreenMode = (mode: string) => {
    if (mode === undefined) return

    const newStyles = this.colorsService.updateCurrentTheme(mode)
    this.setState({ stylesString: newStyles })
  }

  /**
   * @INFO handle de logout para quitar los estilos
   * @param state
   */
  handleLogout = (state: boolean) => {
    if (!state) {
      this.setState({ stylesString: '' })
      this.userService.setI18nCustom()
    }
  }

  handleChatbotChange = (state: IChatbotState) => {
    if (!state) return
    this.setState({
      chatbotOpen: state.open
    })
  }

  setChatbotStyles = () => {
    const intervalChat = setInterval(() => {
      // @ts-ignore
      var parentChat: HTMLDivElement = document.getElementsByTagName('IFRAME')?.Botmaker?.parentElement
      if (parentChat) {
        if (parentChat.classList.contains(CLASS_NAME_CHATBOT)) {
          clearInterval(intervalChat)
        } else {
          parentChat.classList.add(CLASS_NAME_CHATBOT)
        }
      }
    }, INTERVAL_STYLES_CHATBOT)
  }

  render() {
    return(
      <Fragment>
        <FaviconCommonLayout favicon={this.state.favicon}/>
        <TitleCommonLayout title={this.state.title}/>
        <PreloaderCommonLayout classes={this.state.preloader} />
        <SupportButtonCommon
          open={this.state.chatbotOpen}
          inRealTimeSupportLink={customs?.inRealTimeSupport || undefined}
          helpDeskLink={customs?.helpdesk || undefined}
          whatsappLink={customs?.whatsapp || undefined}
        />
        <AppNavigatorRoute />
        <GlobalStyle
          style={this.state.stylesString}
        />
        <LoginMoodleByRequest />
      </Fragment>
    )
  }
}

export default connect(mapStatesToProps)(MasterLayout)
